/* src/app/admin/client/client-area/client-area-endorsement/client-area-endorsement.component.scss */
.table-container {
  width: 100%;
}
.button-search {
  border-radius: 10px;
  padding: 2px;
  width: 37px;
  height: 37px;
  margin-left: 2px;
  margin-top: 16px;
}
h4 {
  margin: 20px 0;
}
/*# sourceMappingURL=client-area-endorsement.component-4NMID65R.css.map */
